import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CInput from '@/components/CForm/CInput'
import { setReload } from "@/redux/common/action";
import { tableData,tableData1} from './data'
import './index.scss'

import { warningconfirmlistHanndler } from "@/servers/goodsManageApi";
import { savaScore } from "@/servers/storeManageApi";
import {withRouter} from "react-router-dom";
import {Checkbox, message, Modal, Select} from 'antd'
const { Option} = Select

@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.searchHandler = this.searchHandler.bind(this)
    this.resetHandler = this.resetHandler.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangelevel = this.onChangelevel.bind(this)
    this.onChangeName = this.onChangeName.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    columns1: tableData1.tHead,
    dataSource1: tableData1.tBody,
    page: tableData.tPage,
    cutdata:[],
    loading: true,
    loading1:true,
    level:0,
    modal: {
      title: '删除数据',
      visible: false,
    },
    deleteid:'',
    annual: '',
    museumname: '',
    ownerlist:[],
    options:[],
    detaildata:[]
  };


  searchHandler(){
    this.getListData('seconds')
  }

  onChange(data){
    this.setState({
      annual:data
    },()=>{
      this.getListData('seconds')
    })
  }

  onChangelevel(data){
    this.setState({
      levelid:data
    })
  }

  onChangeName(data){
    this.setState({
      museumname:data
    })
  }

  resetHandler(){
    this.setState({
      annual:'',
      museumname: ''
    },()=>{
      this.getListData()
    })
  }

  modalCancel(){
    this.setState({
      modal: {...this.state.modal, visible: false},
      dataSource1:[]
    })
  }

  modalOk(){
    const params =[]
    this.state.dataSource2.forEach(item=>{
      params.push({id:item.id,score:item.score})
    })
    savaScore(params).then(res=>{
      if (res.statecode === 0) {
        message.success('保存成功');
        this.modalCancel()
        this.getListData()
      } else {
        message.error('保存失败');
      }
    })
  }

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const params = {
      museumname:this.state.museumname,
      annual:this.state.annual
    }
    warningconfirmlistHanndler(params).then(res=>{
      if (res.statecode === 0) {
        const arr = []
        res.records[0].annuallist.forEach(item=>{
          let obj = {}
          obj.name = item
          obj.value = item
          arr.push(obj)

        })
        this.setState({
          dataSource: res.records[0].scorelist,
          ownerlist: arr,
          loading:false
        });
      }
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  deleteHandler(data){
    this.setState({
      detaildata:data,
      modal: {...this.state.modal, visible: true},
      loading1:true
    })
    setTimeout(()=>{
      this.setState({
        dataSource1:data.scoredetaillist,
        loading1:false
      })
    },500)
  }

  computeds(data){
    return Number(data.score) === 0? false:true
  }

  onChangescore(id){
    const params = this.state.dataSource1
    params.forEach(item=>{
      if (item.id === id) {
        item.score = item.score === '0' ? '1' : '0'
      }
    })
    this.setState({
      dataSource1:params
    })
  }



  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }

  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <Select
                  placeholder='请选择评估年度'
                  onChange={this.onChange}
                  style={{width:'200px'}}
              >
                {
                  this.state.ownerlist.map((item, index)=>{
                    return <Option key={index} value={item.value}>{item.name}</Option>
                  })
                }
              </Select>
              <CInput
                  value={this.state.museumname}
                  placeholder='请输入馆名'
                  style={{width:'200px'}}
                  onChange={this.onChangeName} />
              <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
              <CButton type='primary' onClick={this.resetHandler}>重置</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.deleteHandler(record)}>编辑</CButton>
                    </div>
                )} />
          </CTable>
          <Modal
              visible={this.state.modal.visible}
              onOk={this.modalOk}
              onCancel={this.modalCancel}
              okText='保存'
              cancelText='返回'
              closable={false}
              width={700}
          >
            <div className='detail-container' >
              <div>
                <h4 style={{marginBottom:'20px'}}>减分审核：{this.state.detaildata.museumname}，减分前总分{this.state.detaildata.scoretotal}分</h4>
                <CTable ref='userManageList' loading={this.state.loading1} checked={false} columns={this.state.columns1} dataSource={this.state.dataSource1}>
                  <div
                      slot='index'
                      render={(text, record, index) => (
                          <div className='operate'>
                            {index+1}
                          </div>
                      )} />
                  <div
                      slot='operate'
                      render={(text, record, index) => (
                          <div className='operate'>
                            <Checkbox
                                checked={this.computeds(record)}
                                onChange={()=>{this.onChangescore(record.id)}}
                            >
                              确认减分
                            </Checkbox>
                          </div>
                      )} />
                </CTable>
              </div>
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
